/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeneralSportsPreferencesFromJSON, GeneralSportsPreferencesToJSON, } from "../models";
import * as runtime from "../runtime";
/**
 *
 */
export class PreferencesApi extends runtime.BaseAPI {
    /**
     */
    async calendarApiUsersUserIdSportsPreferencesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling calendarApiUsersUserIdSportsPreferencesGet.");
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) {
                headerParameters.Authorization = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calendar/api/users/{userId}/sports/preferences`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "GET",
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralSportsPreferencesFromJSON(jsonValue));
    }
    /**
     */
    async calendarApiUsersUserIdSportsPreferencesGet(requestParameters, initOverrides) {
        const response = await this.calendarApiUsersUserIdSportsPreferencesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async calendarApiUsersUserIdSportsPreferencesPutRaw(requestParameters, initOverrides) {
        if (requestParameters.userId === null ||
            requestParameters.userId === undefined) {
            throw new runtime.RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling calendarApiUsersUserIdSportsPreferencesPut.");
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters["Content-Type"] = "application/json-patch+json";
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);
            if (tokenString) {
                headerParameters.Authorization = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calendar/api/users/{userId}/sports/preferences`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: "PUT",
            headers: headerParameters,
            query: queryParameters,
            body: GeneralSportsPreferencesToJSON(requestParameters.generalSportsPreferences),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => GeneralSportsPreferencesFromJSON(jsonValue));
    }
    /**
     */
    async calendarApiUsersUserIdSportsPreferencesPut(requestParameters, initOverrides) {
        const response = await this.calendarApiUsersUserIdSportsPreferencesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
